import React, { useState, useEffect } from 'react'
import moment from 'moment';
import * as Constants from '../../../requests/URLConstants';
import callPostApi from "../../../requests/PostRequests";
import callGetApi from "../../../requests/GetRequests";
import { ModalComponentWithInlineLoading } from "common/ModalComponentWithInlineLoading";
import * as IncidentDetailsConstants from './IncidentDetailsConstants';

var config = require('../../../config/appConfig.json');

const IncidentDetailsCollaboration = (props) => {
	const [submittingCollaborationData, setSubmittingCollaborationData] = useState(false);
	const [collaborationSuccess, setCollaborationSuccess] = useState(false);
	const [collaborationSuccessMessage, setCollaborationSuccessMessage] = useState();
	const PROCESSPAYLOAD = config.serverUrl + Constants.PROCESSPAYLOAD;

	const prepareMsteamsMsg = (rcaDetails, impactDetails) => {
		let body = {};
		let incURL = config.clientUrl + "/incidentDetails/alert/" + props.incidentDetailsData.sys_id;
		let incidentCreationTime = new Date(props.incidentDetailsData.sysTime);
		let creationTimeStr = moment(incidentCreationTime).format('MMMM Do, YYYY h:mma');
		let domain = props.incidentDetailsData.u_technology === 'SAP' ? "SAP Operations" : "Automation Operations";
		let payload = {
			"@type": "MessageCard",
			"@context": "https://schema.org/extensions",
			"summary": "New Incident Report",
			"themeColor": "0078D7",
			"title": "New Incident Report"
		};
		let sections = [];
		let factSection = {
			"activityTitle": domain + " - [" + props.incidentDetailsData.number + "](" + incURL + ")",
			"activitySubtitle": "*" + creationTimeStr + "*",
			"activityImage": "https://test/img.png",
			"facts": [
			]
		};

		let entity = props.incidentDetailsData.u_process_id;
		let alertName = props.incidentDetailsData.short_description;
		let impact = props.incidentDetailsData.impact;
		let urgency = props.incidentDetailsData.urgency;
		let priority = props.incidentDetailsData.priority;
		let assignedTo = props.incidentDetailsData.assigned_to;
		let assignmentGroup = props.incidentDetailsData.assignment_group;
		let incidentFacts = [];
		incidentFacts.push(
			{"name": "Managed Object", "value": entity},
			{"name": "Alert Name", "value": alertName},
			{"name": "Impact", "value": impact},
			{"name": "Urgency", "value": urgency},
			{"name": "Priority", "value": priority},
			{"name": "Assigned to", "value": assignedTo},
			{"name": "Assignment Group", "value": assignmentGroup}
		);
		factSection.facts = incidentFacts;
		sections.push(factSection);
		let correlatedAlerts = rcaDetails.corrAlerts;
		let pastFailures = rcaDetails.recentIncidents;
		let pastCRs = rcaDetails.confItemChangeReqInfo;
		//Impact
		let impactContainer = {
			"activityTitle": "**Impacts:**",
			"text": ""
		}

		let impacts = impactDetails.children ? impactDetails.children : null;
		let impactText = "";
		if (impacts && impacts.length > 0) {
			impacts.forEach(impact => {
				impactText = impactText + "*Managed Object* - " + impact.name + " : *Type* - " + impact.nodeType + "<br>";
			})
			impactContainer.text = impactText;
			sections.push(impactContainer);
		}
		//correlation
		let correlationContainer = {
			"activityTitle": "**Correlated Alerts:**",
			"text": ""
		}
		let correlationText = "";
		if (correlatedAlerts && correlatedAlerts.length > 0) {
			correlatedAlerts.forEach(alert => {
			if (alert._source) {
				let incidentURL = alert._source.incident_url;
				let splitStr = incidentURL ? incidentURL.split('sys_id=') : "";
				let sysId = splitStr ? splitStr[1] : null;
				let url = config.clientUrl + "/incidentDetails/alert/" + sysId;
				let incidentNo = alert._source.incident_id ? alert._source.incident_id : alert._source.incident;
				let info = alert._source.info ? alert._source.info : alert._source.dependency_type_classification;
				correlationText = correlationText + "Incident [" + incidentNo + "](" + url + ") : " + info + "<br>";
			}
		})

		correlationContainer.text = correlationText;
		sections.push(correlationContainer);
		}
		//latest failures
		let failuresContainer = {
			"activityTitle": "**Latest Failures:**",
			"text": ""
		};
		let failuresText = "";
		if (pastFailures && pastFailures.length > 0) {
			pastFailures.forEach(failure => {
				let incidentNo = failure.number;
				let issue = failure.short_description;
				let resolution = failure.close_notes;
				let url = config.clientUrl + "/incidentDetails/alert/" + failure.sys_id;
				failuresText = failuresText + "Incident [" + incidentNo + "](" + url + ") : *Issue* - " + issue + " : *Resolution* - " + resolution + "<br>";
			});
			failuresContainer.text = failuresText;
			sections.push(failuresContainer);
		}

		//latest changes
		let changesContainer = {
			"activityTitle": "**Latest CRs:**",
			"text": ""
		};
		let changesText = "";
		if (pastCRs && pastCRs.length > 0) {
			pastCRs.forEach(CR => {
				let CRNumber = CR.number;
				let change = CR.short_description;
				changesText = changesText + "*CR Number* - " + CRNumber + " : *Change* - " + change + "<br>";
			})
			changesContainer.text = changesText;
			sections.push(changesContainer);
		}
		//Comments
		let commentStr = props.incidentDetailsData.comments_and_work_notes;
		let commentArr = commentStr.split("\n");
		const commentsFiltered = commentArr.filter(el => {
			return el != null && el !== '';
		});
		const top10Comments = commentsFiltered.slice(0, 30);
		let commentsStringFinal = "";
		if (top10Comments && top10Comments.length > 0) {
			top10Comments.forEach(e1 => {
				commentsStringFinal = commentsStringFinal + e1 + "<br>";
			});
		}
		let commentsContainer = {
			"activityTitle": "**Comments:**",
			"text": commentsStringFinal
		};
		sections.push(commentsContainer);
		payload.sections = sections;
		let potentialAction = [];
		// add comments container
		let addCommentsContainer = {
			"@type": "ActionCard",
			"name": "Comments",
			"inputs": [
				{
					"@type": "TextInput",
					"id": "comment",
					"isMultiline": true,
					"title": IncidentDetailsConstants.EnterYourComment
				}
			],
			"actions": [
				{
					"@type": "HttpPOST",
					"name": "OK",
					"target": PROCESSPAYLOAD,
					"body": "{\"comment\":\"{{comment.value}}\", \"incidentNo\": \"" + props.incidentDetailsData.number + "\"}"
				}
			]
		}
		potentialAction.push(addCommentsContainer);
		payload.potentialAction = potentialAction;
		body.payload = payload;
		body.tool = "msteams";
		return body;
	};

	const prepareSlackMsg = (rcaDetails, impactDetails) => {
		let body = {};
		const divider = {
			"type": "divider"
		};
		let blocksArray = [];
		let headerBlock = {};
		let correlatedAlerts = rcaDetails.corrAlerts;
		let pastFailures = rcaDetails.recentIncidents;
		let pastCRs = rcaDetails.confItemChangeReqInfo;
		//header
		headerBlock.type = 'header';
		let headerJson = {};
		let incURL = config.clientUrl + "/incidentDetails/alert/" + props.incidentDetailsData.sys_id;
		headerJson.text = ":outage-alert:  New Incident - " + props.incidentDetailsData.number;
		headerJson.type = "plain_text";
		headerBlock.text = headerJson;
		blocksArray.push(headerBlock);
		//context
		let incidentCreationTime = new Date(props.incidentDetailsData.sysTime);
		let creationTimeStr = moment(incidentCreationTime).format('MMMM Do, YYYY h:mma');
		let domain = props.incidentDetailsData.u_technology === 'SAP' ? "SAP Operations" : "Automation Operations";
		let contextBlock = {};
		let contextJson = {};
		contextJson.text = "*" + creationTimeStr + "*" + " | " + domain;
		contextJson.type = "mrkdwn";
		contextBlock.elements = [contextJson];
		contextBlock.type = 'context';
		blocksArray.push(contextBlock);
		blocksArray.push(divider);
		//description
		let entity = props.incidentDetailsData.u_process_id;
		let alertName = props.incidentDetailsData.short_description;
		let impact = props.incidentDetailsData.impact;
		let urgency = props.incidentDetailsData.urgency;
		let priority = props.incidentDetailsData.priority;
		let assignedTo = props.incidentDetailsData.assigned_to;
		let assignmentGroup = props.incidentDetailsData.assignment_group;
		let descBlock = {};
		descBlock.type = "section";
		let descJson = {};
		descJson.type = "mrkdwn";
		descJson.text = "*Managed Object: * " + entity + "\n" +
		  "*Alert Name: * " + alertName + "\n" +
		  "*Impact: * " + impact + "\n" +
		  "*Urgency: * " + urgency + "\n" +
		  "*Priority: * " + priority + "\n" +
		  "*Assigned To: * " + assignedTo + "\n" +
		  "*Assignment Group: * " + assignmentGroup + "\n\n" +
		  "<" + incURL + "|*Details*>";
		descBlock.text = descJson;
		blocksArray.push(descBlock);
		blocksArray.push(divider);
		//Impact
		let impactBlock = {};
		impactBlock.type = "section";
		let impactJson = {};
		impactJson.type = "mrkdwn";
		impactJson.text = ":impact: * Impact*" + "\n";

		let impacts = impactDetails.children ? impactDetails.children : null;
		if (impacts) {
			impacts.forEach(impact => {
				impactJson.text = impactJson.text + "*Managed Object* - " + impact.name + " : *Type* - " + impact.nodeType + "\n";
			});
		}
		impactBlock.text = impactJson;
		blocksArray.push(impactBlock);
		blocksArray.push(divider);
		//correlation
		let correlationBlock = {};
		correlationBlock.type = "section";
		let correlationJson = {};
		correlationJson.type = "mrkdwn";
		correlationJson.text = ":link: *Correlated Alerts*" + "\n";
		correlatedAlerts.forEach(alert => {
			if (alert._source) {
				let incidentURL = alert._source.incident_url;
				let splitStr = incidentURL ? incidentURL.split('sys_id=') : "";
				let sysId = splitStr ? splitStr[1] : null;
				let url = config.clientUrl + "/incidentDetails/alert/" + sysId;
				let incidentNo = alert._source.incident_id ? alert._source.incident_id : alert._source.incident;
				let info = alert._source.info ? alert._source.info : alert._source.dependency_type_classification;
				correlationJson.text = correlationJson.text + "*Incident* - " + "<" + url + "|" + incidentNo + "> : " + info + "\n";
			}
		});
		correlationBlock.text = correlationJson;
		blocksArray.push(correlationBlock);
		blocksArray.push(divider);
		//latest failures
		let failuresBlock = {};
		failuresBlock.type = "section";
		let failuresJson = {};
		failuresJson.type = "mrkdwn";
		failuresJson.text = ":tools: *Past Failures & Resolution * \n";
		pastFailures.forEach(failure => {
			let incidentNo = failure.number;
			let issue = failure.short_description;
			let resolution = failure.close_notes;
			let url = config.clientUrl + "/incidentDetails/alert/" + failure.sys_id;
			failuresJson.text = failuresJson.text + "*Incident* - <" + url + "|" + incidentNo + ">" + " : *Issue* - " + issue + " : *Resolution* - " + resolution + "\n";
		})
		failuresBlock.text = failuresJson;
		blocksArray.push(failuresBlock);
		blocksArray.push(divider);

		//latest changes
		let changesBlock = {};
		changesBlock.type = "section";
		let changesJson = {};
		changesJson.type = "mrkdwn";
		changesJson.text = ":changes: *Past Change Requests*\n";
		pastCRs.forEach(CR => {
		  let CRNumber = CR.number;
		  let change = CR.short_description;
		  changesJson.text = changesJson.text + "*CR Number* - " + CRNumber + " : *Change* - " + change + "\n";
		})
		changesBlock.text = changesJson;
		blocksArray.push(changesBlock);
		blocksArray.push(divider);

		//Comments
		let commentStr = props.incidentDetailsData.comments_and_work_notes;
		// let formattedComments = commentStr.replace("↵↵", "\n");
		//let formattedComments="2021-02-14 21:36:29 - Pramod Bhade (Work notes) Database service in failed state. Conflicted process on host.\n 2021-02-14 02:42:09 - AOCC BOT (Work notes) No Guided Procedure.Guided procedure steps are not configured for the alert: SAP Host Agent not running. Please take care of the issue manually.";
		let commentArr = commentStr.split("\n");
		const commentsFiltered = commentArr.filter(el => {
			return el != null && el != '';
		});
		const top10Comments = commentsFiltered.slice(0, 10);
		let commentsStringFinal = "";
		if (top10Comments && top10Comments.length > 0) {
			top10Comments.forEach(e1 => {
				commentsStringFinal = commentsStringFinal + e1 + "\n";
			});
		}
		let commentsBlock = {};
		commentsBlock.type = "section";
		let commentsJson = {};
		commentsJson.type = "mrkdwn";
		commentsJson.text = ":git-comments: *Comments*" + "\n" + commentsStringFinal;
		commentsBlock.text = commentsJson;
		commentsBlock.accessory = {
		  "type": "button",
		  "action_id": "add_notes",
		  "text": {
				"type": "plain_text",
				"text": "Add",
				"emoji": true
			}
		};
		blocksArray.push(commentsBlock);
		blocksArray.push(divider);
		let payload = {};
		payload.blocks = blocksArray;
		body.payload = payload;
		body.tool = "slack";
		return body;
	};

	const submitCollaboration = async () => {
		setSubmittingCollaborationData(true);
		setCollaborationSuccess(false);
		setCollaborationSuccessMessage('Submitting!');
		let tool = config.collaborationTool;
		let rcaDetails = await callGetApi(Constants.ROOTCAUSEANALYSIS + props.incidentDetailsData.number, { 'Content-Type': 'application/json' });
		let technology = props.incidentDetailsData.u_technology;
		let impactURL = "";
		let u_resource = encodeURI(props.incidentDetailsData.u_resource);
		if (technology === "SAP") {
			impactURL = Constants.SAPFAILUREIMPACTURL + props.incidentDetailsData.u_process_id + '/' + u_resource;
		} else {
			impactURL = props.alertType === "alert" ? Constants.IMPACTDATAURL + props.incidentDetailsData.number : Constants.DEPENDENCEYFAILUREIMPACTURL + props.incidentDetailsData.number;
		}
		let impactDetails = await callGetApi(impactURL, { 'Content-Type': 'application/json' });
		let bodyJSON;
		switch (tool) {
			case "slack":
				bodyJSON = prepareSlackMsg(rcaDetails, impactDetails)
			break;
			case "msteams":
				bodyJSON = prepareMsteamsMsg(rcaDetails, impactDetails)
			break;
			default:
				break;
		}
		callPostApi(Constants.POSTCOLLABORATIONURL, {
			'Content-Type': 'application/json'
		}, bodyJSON)
		.then(result => {
			setSubmittingCollaborationData(false);
			setCollaborationSuccess(true);
			setCollaborationSuccessMessage('Submitted');
		})
		.catch((error) => {
			setSubmittingCollaborationData(false);
			console.error('Error:', error);
		});
	};

	const modalFooterLoginSession = () => ({
		primaryButtonText: "Submit",
		primaryButtonKind: "primary",
		secondaryButtonText: "Cancel",
		secondaryButtonKind: "secondary"
	});

	return (
		<>
			{props.showCollaborationModal &&
				<ModalComponentWithInlineLoading kind="danger"
				children={IncidentDetailsConstants.postToCollaborationToolQuestion}
				isSubmitting={submittingCollaborationData} success={collaborationSuccess}
				description={collaborationSuccessMessage} modalFooter={modalFooterLoginSession()}
				onClickSecondary={props.toggleCollaborationModal} onClick={submitCollaboration} />
			}
		</>
	);
};

export default IncidentDetailsCollaboration;